module.exports = __webpack_public_path__ + "img/logo_cash-full-no-bg-maroom.fe147185.png";